<template>
    <div class="report__box-button">
        <ButtonCommon
            :isNoHover="true"
            :isLoadingWhiteColor="true"
            :isLoading="isLoadingButton"
            className="w100"
            type="active"
            icon="print"
            value="print"
            @on-click-button-common="() => onCheckPrint()"
        />
    </div>
    <Dialog
        :show="isOpenDialog"
        @close="onCloseReport"
        @accept="onMakeAFinalReport"
        content="confirm final print"
        title="Confirmation"
        :isShowTable="true"
        :dataTable="dataTable"
        :buttonLeftName="`close`"
        :buttonRightName="`print`"
    />
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';

import ButtonCommon from '@/components/common/button/button.vue';
import Dialog from '@/components/common/dialog/dialog.vue';

import reportService from '@/services/report/report.service';
import printMixins from '@/mixins/print-mixins';

export default {
    mixins: [languageMixins, utilsMixin, printMixins],
    components: { ButtonCommon, Dialog },
    props: {
        dataSource: {
            type: Object,
            default: () => null,
        },
        dataReport: {
            type: Array,
            default: () => null,
        },
        cashier: {
            type: Object,
            default: () => null,
        },
        isFinal: {
            type: Boolean,
            default: true,
        },
        valueDate: {
            type: String,
            default: '',
        },
        dateTo: {
            type: String,
            default: '',
        },
        dateFrom: {
            type: String,
            default: '',
        },
        dataSummary: {
            type: Object,
            default: () => null,
        },
        displays: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localCashier: this.cashier,
            isOpenDialog: false,
            isLoadingButton: false,
            config: null,
        };
    },
    created() {
        const index = this.$store.state.config.features.findIndex((x) => x.name === 'report');

        if (index !== -1) this.config = this.$store.state.config.features[index];
    },
    methods: {
        onCheckPrint() {
            this.isFinal ? this.onCheckPrintReportFinal() : this.onPrintReport();
        },

        onCheckPrintReportFinal() {
            if (this.localCashier) this.localCashier['title'] = 'Final report of';

            if (this.localCashier && this.localCashier.locked === true) {
                this.onPrintReport();
                return false;
            } else if (this.localCashier) {
                this.isOpenDialog = true;
            } else {
                this.$router.go(-1);
            }
        },

        onCloseReport() {
            const query = this.$route.query;

            this.$router.push({ path: '/', query });
        },

        onPrintReport() {
            this.isLoadingButton = true;
            let valueDate = this.valueDate;
            const param = {
                localCashier: this.localCashier,
                summary: this.dataSummary,
                displays: this.displays,
                report: this.dataReport,
                date: valueDate,
                from: this.dateFrom,
                to: this.dateTo,
                isFinal: this.isFinal,
            };
            this.printReport(param);
            setTimeout(() => {
                this.isLoadingButton = false;
            }, 1500);
        },

        async onMakeAFinalReport() {
            try {
                this.isLoadingButton = true;
                const resp = await reportService.makeAFinalReport();
                if (resp.code === 200 || resp.status === 'success') {
                    this.onPrintReport();
                    this.isOpenDialog = false;
                    this.$router.go(-1);
                } else this.$router.go(-1);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
